import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import Icon from '../../../ui/Icon'
import { ReactComponent as VideoPlay } from '../../../../images/svg/videoPlay.svg'
import { ReactComponent as VideoPause } from '../../../../images/svg/videoPause.svg'
import { ReactComponent as VideoVolume } from '../../../../images/svg/videoVolume.svg'
import { ReactComponent as VideoVolumeMuted } from '../../../../images/svg/videoVolumeMuted.svg'
import { ReactComponent as VideoFullScreen } from '../../../../images/svg/videoFullScreen.svg'

const StyledVideoControls = styled.div(({ theme: { colors } }) => ({
  color: colors.white,
  marginBottom: '10px',
  position: 'relative',
  height: '70%',
}))

const StyledVolume = styled.div(() => ({
  cursor: 'pointer',
  height: '24px',
  position: 'absolute',
  left: 0,
  top: '50%',
  transform: 'translateY(-50%)',
  width: '24px',
}))

const StyledFullScreen = styled.div(() => ({
  cursor: 'pointer',
  height: '24px',
  position: 'absolute',
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)',
  width: '24px',
}))

const StyledPlay = styled.div(() => ({
  width: '48px',
  height: '48px',
  cursor: 'pointer',
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
}))

const VideoControls = ({
  togglePlaying,
  toggleFullscreen,
  toggleMuted,
  muted,
  playing,
}) => (
  <StyledVideoControls>
    <StyledVolume onClick={toggleMuted}>
      {
        muted ? (
          <Icon><VideoVolumeMuted /></Icon>
        ) : (
          <Icon><VideoVolume /></Icon>
        )
      }
    </StyledVolume>
    <StyledPlay onClick={togglePlaying}>
      {
        playing ? (
          <Icon><VideoPlay /></Icon>
        ) : (
          <Icon><VideoPause /></Icon>
        )
      }
    </StyledPlay>
    <StyledFullScreen onClick={() => toggleFullscreen()}>
      <Icon><VideoFullScreen /></Icon>
    </StyledFullScreen>
  </StyledVideoControls>
)

VideoControls.propTypes = {
  togglePlaying: PropTypes.func.isRequired,
  toggleFullscreen: PropTypes.func.isRequired,
  toggleMuted: PropTypes.func.isRequired,
  muted: PropTypes.bool.isRequired,
  playing: PropTypes.bool.isRequired,
}

export default VideoControls
